<template>
  <div>
    <vuetable @on="$listeners" :class="classes" :css="Object.assign(css.table,extraCss.table)"
   :api-url="apiUrl" :per-page="perPage" :row-class="onRowClass" :append-params="moreParams" :http-options="tokenHeader" @vuetable:checkbox-toggled="onCheckboxToggled" :fields="fields" @table-switch-event="onTableSwitchEvent" data-path="data" pagination-path="" ref="vuetable" @vuetable:pagination-data="onPaginationData" @vuetable:loading="loading" @vuetable:load-success="loadSuccess">    

      <!-- Pass on all scoped slots -->
      <template v-for="slot in Object.keys($scopedSlots)" :slot="slot" scope="props">
        <slot :name="slot" v-bind="props"/>
      </template>
    </vuetable>
    <div v-if="!disablePagination" class="vuetable-pagination">
      <vuetable-pagination-info class="pull-left" ref="paginationInfo" info-class="pagination-info"></vuetable-pagination-info>
      <vuetable-pagination-custom class="pull-right" ref="pagination" @vuetable-pagination:change-page="onChangePage"></vuetable-pagination-custom>
    </div>
  </div>
</template>

<script>

import VuetablePaginationCustom from './VuetablePaginationCustom'
import Sortable from 'sortablejs'
export default {
  components: {
    VuetablePaginationCustom
  },
  props: {
    perPage: {
      type: Number,
      default: 10,
      required: false
    },
    onCheckboxToggled: {
      type: Function,
      default: () => {},
      required: false
    },
    disablePagination: {
      type: Boolean,
      default: false,
      required: false
    },
    sortable: {
      type: Boolean,
      default: false,
      required: false
    },
    onRowClass: {
      type: Function,
      default: () => {},
      required: false
    },
    sortableFunction: {
      type: Function,
      default: () => {},
      required: false
    },
    classes: {
      type: String,
      default: ''
    },
    extraCss: {
      type: Object,
      default: () => { return {table: ''} }
    },
    apiUrl: {
      type: String,
      default: ''
    },
    fields: {
      type: Array,
      required: true
    },
    dataVar: {
      type: Array
    },
    moreParams: {
      required: false
    }
  },
  data: function () {
    return {
      sortObject: null,
      css: {
        table: {
          handleIcon: 'fa fa-bars text-secondary'
        }
      },
      tokenHeader: {
        headers: {'Authorization': 'Bearer ' + this.$auth.token()}
      }
    }
  },
  methods: {
    loading: function () {
      this.$notify({
        group: 'full',
        text: this.$t('Reloading data..'),
        position: 'top center'
      })
    },
    loadSuccess: function () {
      console.log('Data reloaded')
      var vm = this
      if (this.sortObject === null && this.sortable === true) {
        this.sortObject = new Sortable(this.$refs.vuetable.$el.querySelector('tbody'), {
          handle: '.handle-icon',
          dataIdAttr: 'item-index',
          onEnd: function (evt) {
            var order = vm.sortObject.toArray()
            var newOrder = []
            var tableData = vm.$refs.vuetable.tableData
            for (var i = 0; i < order.length; i++) {
              newOrder.push({newOrder: i + 1, oldOrder: order[i], id: tableData[order[i]].id, name: tableData[order[i]].free_text})
            }
            vm.$emit('sortChanged', newOrder)
          }
        })
      }
      /* this.$notify({
        group: 'full',
        text: this.$t('Data reloaded'),
        position: 'top center'
      }) */
    },
    onChangePage: function (page) {
      this.$refs.vuetable.changePage(page)
    },
    onPaginationData: function (paginationData) {
      if (!this.disablePagination) {
        this.$refs.pagination.setPaginationData(paginationData)
        this.$refs.paginationInfo.setPaginationData(paginationData)
      }
    },
    onTableSwitchEvent: function (data) {
      this.$emit('table-switch-event', data)
    }
  },
  watch: {
    moreParams: function () {
      this.$nextTick(() => this.$refs.vuetable.refresh())
    }
  },
  events: {
    'refresh-table-data' () {
      this.$nextTick(() => this.$refs.vuetable.refresh())
    },
    'filter-set' (filterText) {
      this.moreParams = {
        filter: filterText
      }
      this.$nextTick(() => this.$refs.vuetable.refresh())
    },
    'filter-reset' () {
      this.moreParams = {}
      this.$nextTick(() => this.$refs.vuetable.refresh())
    }
  }
}
</script>



// WEBPACK FOOTER //
// CustomVueTable.vue?37d4d9b3